import { render, staticRenderFns } from "./ngo-registered-details.vue?vue&type=template&id=e629f910&scoped=true&"
import script from "./ngo-registered-details.vue?vue&type=script&lang=js&"
export * from "./ngo-registered-details.vue?vue&type=script&lang=js&"
import style0 from "./ngo-registered-details.vue?vue&type=style&index=0&id=e629f910&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e629f910",
  null
  
)

export default component.exports